import { render, staticRenderFns } from "./department-allocation.vue?vue&type=template&id=0061c89e&"
import script from "./department-allocation.vue?vue&type=script&lang=js&"
export * from "./department-allocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports